<ng-container *ngIf="content$ | async as content">
<div class="hero-banner">
  <div class="hero-overlay">
    <h1 class="hero-title">Refund Policy</h1>
  </div>
</div>

<div class="refund-policy-container">
  <div class="content-section">
    <div class="content-text">
      @if (content.refund.policy.mode === 'unavailable') {
        <section class="policy-unavailable" aria-labelledby="refund-unavailable-title">
          <h2 id="refund-unavailable-title" class="section-title font-hd">Policy unavailable</h2>
          <p class="section-text font-sm">{{ content.refund.policy.unavailableMessage }}</p>
          @if (content.refund.policy.supportMailto) {
            <a [href]="content.refund.policy.supportMailto">Contact {{ content.refund.policy.supportEmail }}</a>
          }
        </section>
      } @else {
        @if (content.refund.policy.document.introduction) {
          <p class="policy-introduction policy-pre-line font-sm">{{ content.refund.policy.document.introduction }}</p>
        }
        @for (section of content.refund.policy.document.sections; track $index) {
          <section class="policy-section" [class.note-text]="section.kind === 'notice'">
            <h2 class="section-title font-hd">{{ section.heading }}</h2>
            @if (section.body) {
              <p class="section-text policy-pre-line font-sm">{{ section.body }}</p>
            }
            @if (section.items.length) {
              <ul class="policy-list font-sm">
                @for (item of section.items; track $index) {
                  <li>{{ item.text }}
                    @if (item.subitems.length) {
                      <ul>
                        @for (subitem of item.subitems; track $index) { <li>{{ subitem }}</li> }
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
          </section>
        }
      }
    </div>
  </div>
</div>

<app-footer></app-footer>
</ng-container>
